// extracted by mini-css-extract-plugin
export default {"registrationSuccessPage":"RegistrationSuccessPage_registrationSuccessPage__Avm8A","confirmationBlock":"RegistrationSuccessPage_confirmationBlock__8YqCp"};